var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement"},[_c('div',{staticClass:"init"},[_c('div',{staticClass:"val"},[_c('router-link',{staticClass:"btn",attrs:{"to":"/index"}},[_vm._v(" 캠페인을 실행하세요 ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }